module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/dae93806fd78b5f77d281cd92bd33ffe.png";